import * as React from "react";
import { Sparkles } from "lucide-react";
import { Combobox } from "@/components/ui";
import { cn } from "@/lib/utils";
import { PromptKind } from "@/containers/Coach/Library/PromptsTab/promptKind";

export interface PromptKindFilterProps {
  value: PromptKind;
  onChange: (kind: PromptKind) => void;
  className?: string;
}

type KindItem = { value: PromptKind; label: string; icon?: React.ReactNode };

const ITEMS: KindItem[] = [
  { value: "ALL", label: "All prompts" },
  { value: "STATIC", label: "Standard prompts" },
  { value: "DYNAMIC", label: "Personalized prompts", icon: <Sparkles className="size-3.5" aria-hidden="true" /> },
];

export const PromptKindFilter: React.FC<PromptKindFilterProps> = ({ value, onChange, className }) => {
  const selected = ITEMS.find(item => item.value === value) ?? ITEMS[0];

  return (
    <Combobox
      items={ITEMS}
      value={selected}
      onValueChange={item => onChange((item ?? selected).value)}
      isItemEqualToValue={(item, current) => item.value === current?.value}
      placeholder={ITEMS[0].label}
      className={cn("max-w-40 min-w-40", className)}
    />
  );
};
